"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_saving(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "79338293-aef7-4354-a7b7-cb01b3545ed2",
    "data-name": "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7a426b4c-7e38-4fa4-9054-8c7ef9ca68e8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.19,149.65c0,10.13,27.73,18.34,61.93,18.34,33.57,0,60.88-7.91,61.88-17.78V127.13h-8.85v1.8c-10.81-3.43-30.52-5.73-53.08-5.73S43.81,125.5,33,128.93v-1.8H24.14v22.52Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "741a9976-0fff-490b-81ae-b6b89e8b805e",
    x1: 46,
    y1: 144.14,
    x2: 148,
    y2: 144.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7c02861f-9532-4c6a-a2f6-b3c7fe2c8a89"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.05,121.24c0,10.13,27.72,18.33,61.93,18.33,33.56,0,60.88-7.9,61.88-17.77V98.71H159v1.81c-10.82-3.44-30.52-5.74-53.08-5.74s-42.27,2.3-53.08,5.74V98.71H44v22.53Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "33ab6ef6-de1d-44d1-a343-63ada3947feb",
    x1: 44,
    y1: 98.33,
    x2: 167.86,
    y2: 98.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9f8ff6bf-0072-44cd-a82b-2576d580261c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.19,93.22c0,10.13,27.73,18.34,61.93,18.34,33.57,0,60.88-7.91,61.88-17.78V70.7h-8.85v1.81c-10.81-3.44-30.52-5.74-53.08-5.74S43.81,69.07,33,72.51V70.7H24.14V93.22Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ff398757-a161-4f8e-b347-5ae70f3e29df",
    x1: 33,
    y1: 88.3,
    x2: 148,
    y2: 88.3,
    xlinkHref: "#741a9976-0fff-490b-81ae-b6b89e8b805e"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "bd6d7c34-e908-4979-955f-f183bcce7692"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.12,65.24c0,10.13,27.73,18.33,61.93,18.33,33.57,0,60.88-7.9,61.88-17.77V42.71h-8.85v1.81c-10.81-3.44-30.52-5.74-53.08-5.74s-42.27,2.3-53.08,5.74V42.71H32.07V65.24Z",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("title", null, "saving-hi"), /*#__PURE__*/React.createElement("path", {
    d: "M24.19,149.67c0,10.12,27.72,18.33,61.93,18.33,33.6,0,60.93-7.92,61.88-17.81V127.13h-8.85v1.8c-10.81-3.43-30.52-5.73-53.08-5.73S43.81,125.5,33,128.93v-1.8H24.14v22.54Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7a426b4c-7e38-4fa4-9054-8c7ef9ca68e8)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3,130.71V161a89.53,89.53,0,0,0,10.33,3.24V130.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,130.67v37q5,.59,10.29,1.08v-38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.59,139.91v31.65c3.38.12,6.83.22,10.32.3v-32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.23,141.64v27.52q5.24-.06,10.32-.2V141.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.88,140.36v28.8q5.3-.42,10.32-.92V140.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.52,131.23v34.33q5.61-1,10.32-2.24V131.23Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M24.19,149.65c0,10.13,27.73,18.34,61.93,18.34,33.57,0,60.88-7.91,61.88-17.78V127.13h-8.85v1.8c-10.81-3.43-30.52-5.73-53.08-5.73S43.81,125.5,33,128.93v-1.8H24.14v22.52Z",
    opacity: 0.06,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 86.07,
    cy: 126.71,
    rx: 61.93,
    ry: 18.33,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 86.07,
    cy: 126.71,
    rx: 51.61,
    ry: 13.5,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.24,122.6h0c-4.22-3.49-11.3-5.27-17.39-6.52a143.08,143.08,0,0,0-20-2.51,174,174,0,0,0-41.28,2.06c-6.81,1.23-15,3.08-19.7,7h0c-2,1.62-3,3.71-2,5.79s3.43,3.61,5.92,4.79c-2.31-1.89-3.18-4.33-1.57-6.6a14.34,14.34,0,0,1,5.53-4c6.82-3.23,15.33-4.73,23.34-5.71,5.23-.64,10.54-1,15.85-1.18a128.78,128.78,0,0,1,16.32.76c8.55.83,17.45,2.21,25,5.21,2.76,1.09,5.53,2.48,7.22,4.4,2.08,2.37,1.43,5-1.13,7.14,2.48-1.18,4.95-2.74,5.91-4.79S137.21,124.22,135.24,122.6Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.24,122.6h0c-4.22-3.49-11.3-5.27-17.39-6.52a143.08,143.08,0,0,0-20-2.51,174,174,0,0,0-41.28,2.06c-6.81,1.23-15,3.08-19.7,7h0c-2,1.62-3,3.71-2,5.79s3.43,3.61,5.92,4.79c-2.31-1.89-3.18-4.33-1.57-6.6a14.34,14.34,0,0,1,5.53-4c6.82-3.23,15.33-4.73,23.34-5.71,5.23-.64,10.54-1,15.85-1.18a128.78,128.78,0,0,1,16.32.76c8.55.83,17.45,2.21,25,5.21,2.76,1.09,5.53,2.48,7.22,4.4,2.08,2.37,1.43,5-1.13,7.14,2.48-1.18,4.95-2.74,5.91-4.79S137.21,124.22,135.24,122.6Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.19,139.17V125.46l-10.47,2.05-5.19-2.62v-3.78l18.39.19h8.71v17.87Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.19,139.17V125.46l-10.47,2.05-5.19-2.62v-3.78l18.39.19h8.71v17.87Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83.19,135.39V121.68l-10.47,2-5.19-2.62,18.39-3.59h8.71v17.87Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.15,127.13v1.8c-10.81-3.43-30.52-5.73-53.08-5.73S56.82,118.06,46,121.5v1l.62,4L88.09,168c32.66-.3,58.93-8.09,59.91-17.76V127.13Z",
    opacity: 0.2,
    fill: "url(#741a9976-0fff-490b-81ae-b6b89e8b805e)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.05,121.25c0,10.13,27.72,18.34,61.92,18.34,33.61,0,60.94-7.93,61.89-17.81V98.71H159v1.81c-10.82-3.44-30.52-5.74-53.08-5.74s-42.27,2.3-53.08,5.74V98.71H44v22.54Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7c02861f-9532-4c6a-a2f6-b3c7fe2c8a89)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.32,102.3v30.3a89.32,89.32,0,0,0,10.32,3.24V102.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,102.25v37q5,.59,10.3,1.08V102.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.61,111.5v31.65c3.38.12,6.83.22,10.32.3V111.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.25,113.23v27.52c3.48-.05,6.93-.11,10.32-.2V113.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.89,112v28.8q5.31-.42,10.32-.92V112Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.54,97.83v39.32c3.73-.81,7.18-1.67,10.32-2.56V97.83Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M44.05,121.24c0,10.13,27.72,18.33,61.93,18.33,33.56,0,60.88-7.9,61.88-17.77V98.71H159v1.81c-10.82-3.44-30.52-5.74-53.08-5.74s-42.27,2.3-53.08,5.74V98.71H44v22.53Z",
    opacity: 0.06,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.93,
    cy: 98.33,
    rx: 61.93,
    ry: 18.33,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.93,
    cy: 98.28,
    rx: 51.61,
    ry: 13.5,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.09,94.18h0c-4.21-3.5-11.29-5.28-17.38-6.53a144.93,144.93,0,0,0-20-2.51A174.48,174.48,0,0,0,76.47,87.2c-6.82,1.24-15,3.08-19.71,7h0c-2,1.61-3,3.7-2,5.78s3.43,3.61,5.91,4.8c-2.3-1.9-3.17-4.34-1.56-6.61a14.27,14.27,0,0,1,5.53-4c6.81-3.23,15.33-4.73,23.33-5.71,5.24-.64,10.54-1,15.85-1.18a130.74,130.74,0,0,1,16.33.76c8.54.84,17.45,2.22,25,5.21,2.76,1.09,5.54,2.48,7.22,4.4,2.08,2.38,1.44,5-1.13,7.15,2.48-1.19,5-2.75,5.92-4.8S157.07,95.8,155.09,94.18Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.09,94.18h0c-4.21-3.5-11.29-5.28-17.38-6.53a144.93,144.93,0,0,0-20-2.51A174.48,174.48,0,0,0,76.47,87.2c-6.82,1.24-15,3.08-19.71,7h0c-2,1.61-3,3.7-2,5.78s3.43,3.61,5.91,4.8c-2.3-1.9-3.17-4.34-1.56-6.61a14.27,14.27,0,0,1,5.53-4c6.81-3.23,15.33-4.73,23.33-5.71,5.24-.64,10.54-1,15.85-1.18a130.74,130.74,0,0,1,16.33.76c8.54.84,17.45,2.22,25,5.21,2.76,1.09,5.54,2.48,7.22,4.4,2.08,2.38,1.44,5-1.13,7.15,2.48-1.19,5-2.75,5.92-4.8S157.07,95.8,155.09,94.18Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.05,110.74V97l-10.47,2-5.19-2.62V92.68l18.39.19h8.7v17.87Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.05,110.74V97l-10.47,2-5.19-2.62V92.68l18.39.19h8.7v17.87Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.05,107V93.25l-10.47,2-5.19-2.62,18.39-3.59h8.7V107Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.93,
    cy: 98.33,
    rx: 61.93,
    ry: 18.33,
    opacity: 0.2,
    fill: "url(#33ab6ef6-de1d-44d1-a343-63ada3947feb)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.19,93.24c0,10.13,27.72,18.33,61.93,18.33,33.6,0,60.93-7.92,61.88-17.8V70.7h-8.85v1.81c-10.81-3.44-30.52-5.74-53.08-5.74S43.81,69.07,33,72.51V70.7H24.14V93.24Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9f8ff6bf-0072-44cd-a82b-2576d580261c)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3,74.29v30.3a91.54,91.54,0,0,0,10.33,3.24V74.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,74.24v37q5,.58,10.29,1.08v-38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.59,83.48v31.65c3.38.13,6.83.22,10.32.3V83.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.23,85.22v27.51q5.24-.06,10.32-.2V85.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.88,83.93v28.8c3.53-.28,7-.58,10.32-.92V83.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.52,74.81v34.32q5.61-1,10.32-2.23V74.81Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M24.19,93.22c0,10.13,27.73,18.34,61.93,18.34,33.57,0,60.88-7.91,61.88-17.78V70.7h-8.85v1.81c-10.81-3.44-30.52-5.74-53.08-5.74S43.81,69.07,33,72.51V70.7H24.14V93.22Z",
    opacity: 0.06,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 86.07,
    cy: 70.32,
    rx: 61.93,
    ry: 18.33,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 86.07,
    cy: 70.35,
    rx: 61.93,
    ry: 18.33,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 86.07,
    cy: 70.35,
    rx: 51.61,
    ry: 13.5,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.24,66.24h0c-4.22-3.49-11.3-5.28-17.39-6.52a141.59,141.59,0,0,0-20-2.51,174,174,0,0,0-41.28,2c-6.81,1.24-15,3.09-19.7,7h0c-2,1.62-3,3.7-2,5.78s3.43,3.61,5.92,4.8c-2.31-1.89-3.18-4.33-1.57-6.6a14.26,14.26,0,0,1,5.53-4c6.82-3.22,15.33-4.72,23.34-5.7,5.23-.65,10.54-1,15.85-1.18a127,127,0,0,1,16.32.76c8.55.83,17.45,2.21,25,5.21,2.76,1.09,5.53,2.48,7.22,4.4,2.08,2.37,1.43,5-1.13,7.14,2.48-1.18,4.95-2.75,5.91-4.8S137.21,67.86,135.24,66.24Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.24,66.24h0c-4.22-3.49-11.3-5.28-17.39-6.52a141.59,141.59,0,0,0-20-2.51,174,174,0,0,0-41.28,2c-6.81,1.24-15,3.09-19.7,7h0c-2,1.62-3,3.7-2,5.78s3.43,3.61,5.92,4.8c-2.31-1.89-3.18-4.33-1.57-6.6a14.26,14.26,0,0,1,5.53-4c6.82-3.22,15.33-4.72,23.34-5.7,5.23-.65,10.54-1,15.85-1.18a127,127,0,0,1,16.32.76c8.55.83,17.45,2.21,25,5.21,2.76,1.09,5.53,2.48,7.22,4.4,2.08,2.37,1.43,5-1.13,7.14,2.48-1.18,4.95-2.75,5.91-4.8S137.21,67.86,135.24,66.24Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.19,82.81V69.09l-10.47,2-5.19-2.61V64.75l18.39.18h8.71V82.81Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.19,82.81V69.09l-10.47,2-5.19-2.61V64.75l18.39.18h8.71V82.81Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83.19,79V65.32L72.72,67.37l-5.19-2.62,18.39-3.59h8.71V79Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.15,70.7v1.81c-10.81-3.44-30.52-5.74-53.08-5.74S43.82,63.06,33,66.5L34,69l.69,1.5,40.79,40.78c3.46.18,7,.28,10.64.28,33.57,0,60.88-7.91,61.88-17.78V70.7Z",
    opacity: 0.2,
    fill: "url(#ff398757-a161-4f8e-b347-5ae70f3e29df)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.12,65.25c0,10.13,27.72,18.34,61.93,18.34,33.6,0,60.93-7.93,61.88-17.81V42.71h-8.85v1.81c-10.81-3.44-30.52-5.74-53.08-5.74s-42.27,2.3-53.08,5.74V42.71H32.07V65.25Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bd6d7c34-e908-4979-955f-f183bcce7692)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.39,42.5V77.59a82.74,82.74,0,0,0,10.32,3.75V42.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,42.45v42.8q5,.68,10.29,1.25v-44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.68,53.15V89.8c3.38.14,6.83.25,10.32.35v-37Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.32,55.16V87q5.24-.08,10.32-.23V55.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,53.68V87c3.54-.32,7-.68,10.33-1.06V53.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.61,43.11V82.85c3.73-.81,7.18-1.68,10.32-2.59V43.11Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M32.12,65.24c0,10.13,27.73,18.33,61.93,18.33,33.57,0,60.88-7.9,61.88-17.77V42.71h-8.85v1.81c-10.81-3.44-30.52-5.74-53.08-5.74s-42.27,2.3-53.08,5.74V42.71H32.07V65.24Z",
    opacity: 0.06,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 94,
    cy: 42.33,
    rx: 61.93,
    ry: 18.33,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 94,
    cy: 42.33,
    rx: 51.61,
    ry: 13.5,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.17,38.23h0c-4.22-3.5-11.3-5.28-17.39-6.53a145,145,0,0,0-20-2.51,174.57,174.57,0,0,0-41.28,2.06c-6.81,1.24-15,3.08-19.71,7h0c-2,1.61-3,3.7-2,5.78s3.43,3.61,5.92,4.8c-2.31-1.89-3.18-4.34-1.57-6.6a14.19,14.19,0,0,1,5.53-4C59.49,35,68,33.45,76,32.47c5.24-.64,10.54-1,15.86-1.17a128.78,128.78,0,0,1,16.32.75c8.54.84,17.45,2.22,25,5.21,2.75,1.1,5.53,2.48,7.22,4.4,2.08,2.38,1.43,5.05-1.14,7.15,2.48-1.19,5-2.75,5.92-4.8S145.14,39.85,143.17,38.23Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.17,38.23h0c-4.22-3.5-11.3-5.28-17.39-6.53a145,145,0,0,0-20-2.51,174.57,174.57,0,0,0-41.28,2.06c-6.81,1.24-15,3.08-19.71,7h0c-2,1.61-3,3.7-2,5.78s3.43,3.61,5.92,4.8c-2.31-1.89-3.18-4.34-1.57-6.6a14.19,14.19,0,0,1,5.53-4C59.49,35,68,33.45,76,32.47c5.24-.64,10.54-1,15.86-1.17a128.78,128.78,0,0,1,16.32.75c8.54.84,17.45,2.22,25,5.21,2.75,1.1,5.53,2.48,7.22,4.4,2.08,2.38,1.43,5.05-1.14,7.15,2.48-1.19,5-2.75,5.92-4.8S145.14,39.85,143.17,38.23Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.12,54.79V41.08L80.65,43.13l-5.19-2.62V36.74l18.39.18h8.71V54.79Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.12,54.79V41.08L80.65,43.13l-5.19-2.62V36.74l18.39.18h8.71V54.79Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.12,51V37.3L80.65,39.35l-5.19-2.61,18.39-3.6h8.71V51Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }));
}

var _default = ic_saving;
exports.default = _default;